const API_PREFIX = '/web-api'

const ENVIORNMENT = 'development'

const ZERO = 0

const ONE = 1

const GET_REQUEST = 'get'

const POST_REQUEST = 'post'

const PATCH_REQUEST = 'patch'

const PUT_REQUEST = 'put'

const BOOLEAN_TRUE = true

const BOOLEAN_FALSE = false

const NULL = null


module.exports = { 
    API_PREFIX,
    ENVIORNMENT, 
    ZERO,
    ONE,
    GET_REQUEST,
    PUT_REQUEST,
    POST_REQUEST, 
    PATCH_REQUEST,
    BOOLEAN_TRUE,
    BOOLEAN_FALSE, 
    NULL,
}